<template>
  <form class="form">
    <div class="mb-3">
      <label for="signby" class="form-label">Username</label>
      <input
        type="text"
        class="form-control"
        id="signby"
        maxlength="20"
        v-model="singinby"
        placeholder="..."
        required
      />
      <div class="form-text">Der username darf nur aus Kleinbuchstaben bestehen</div>
    </div>
    <div class="mb-3">
      <label for="password" class="form-label">Passwort</label>
      <div class="input-group">
        <input type="password" class="form-control" aria-describedby="basic-addon4" id="password" v-model="password" maxlength="50" placeholder="********" required />
        <span class="btn btn-outline-primary input-group-text" id="basic-addon4" @click="$store.state.utils.switTypeInput">
          <i class="fa-solid fa-eye"></i>
        </span>
      </div>
      <router-link
        :to="{ name: 'ForgotPassword' }"
        custom
        v-slot="{ navigate }"
        id="basic-addon4"
        class="form-text"
      >
        <span
          role="link"
          @click="navigate"
          class="btn btn-link"
          @keypress.enter="navigate"
        >
          Passwort vergessen?
        </span>
      </router-link>
    </div>
    <div class="mb-3">
      <button
        v-if="singinby.length > 3 && password.length > 8"
        @click="submit"
        type="submit"
        class="btn btn-primary"
      >
        Anmelden
      </button>
      <button v-else type="submit" class="btn btn-outline-primary disabled" disabled>
        Anmelden
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: "SignIn",

  data() {
    return {
      singinby: "",
      password: "",
      passwordIsCorrect: false,
      nameIsCorrect: false,
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },

  watch: {
    password() {
      const val = this.$store.state.utils.filters.password(this.password);

      this.passwordIsCorrect =
        val.has_special &&
        val.has_uppercase &&
        val.has_lowercsae &&
        val.has_number &&
        val.has_minimum_lenth;
    },

    singinby() {
      this.singinby = this.singinby.toLowerCase();
      const val = this.$store.state.utils.filters.username(this.singinby);

      this.nameIsCorrect =
        val.has_minimum_lenth && val.only_letters && val.is_mail;
    },
  },

  methods: {
    submit() {
      event.preventDefault();

      if (this.singinby.length < 3 && this.singinby.length > 20) {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: this.$store.state.language.usernameError,
          },
          3000
        );
        return;
      }

      if (this.nameIsCorrect && this.passwordIsCorrect) {
        this.$store.state.utils.processing = true;
        const data = {
          singinby: this.singinby,
          password: this.password,
        };
        this.$store.state.modules.api
          .singIn(data)
          .then((resp) => {
            this.singinby = "";
            this.password = "";
            if (resp.status === 200) {
              this.$store.state.modules.account.user = resp.data.user;
              this.$store.state.modules.account.token = resp.data.token;

              this.$router.push({ name: "LandingPage" });
              setTimeout(() => {
                location.reload();
              }, 100);
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  message: this.$store.state.language.signError,
                },
                2500
              );
            }
            this.$store.state.utils.processing = false;
          })
          .catch((err) => {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
            this.$store.state.utils.processing = false;
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: this.$store.state.language.signInputsError,
          },
          2500
        );
      }
    },
  },
};
</script>
